module.exports = __webpack_public_path__ + "img/accu_imr.43445f45.png";